import {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {toastResponseError} from 'utils/common';
import {useGoogleSignIn} from 'hooks/auth/useGoogleSignIn';
import {AuthPageLoader} from 'pages/Auth/components/AuthPageLoader';

function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const state = searchParams.get('state');
  const code = searchParams.get('code');
  const [stateText, setStateText] = useState('');

  const {oauthGoogleCallback} = useGoogleSignIn();

  useEffect(() => {
    if (state && code) {
      oauthGoogleCallback(
        {code, state},
        {
          onSuccess: () => {
            setStateText('Authentication successful. You can close this tab.');
          },
          onError: () => {
            setStateText('Authentication failed. You can close this tab.');
          },
        },
      );
    }
    if (!state) toastResponseError('State param is missing');
    if (!code) toastResponseError('Code param is missing');
  }, [state, code, oauthGoogleCallback]);

  if (!state) {
    return <AuthPageLoader />;
  }

  return <div style={{padding: '16px'}}>{stateText}</div>;
}

export {OAuthCallback};
